import { RegisterUserDataType } from '@/config/initialState';
import { customerTypes } from '@/consts/customer';
import { RegistCustomerParams } from '@/types/api/registerQRApi';

export const buildRegisterCustomerParams = (
  formData: RegisterUserDataType,
): RegistCustomerParams => {
  const { affiliate_id, sig, isCorporation, step1 } = formData;
  const params: RegistCustomerParams = {
    m_affiliate_id: affiliate_id,
    customer_type: isCorporation
      ? customerTypes.CORPORATION
      : customerTypes.PERSONAL,
    first_name: step1.firstName || undefined,
    family_name: step1.familyName || undefined,
    first_name_kana: step1.firstNameKana || undefined,
    family_name_kana: step1.familyNameKana || undefined,
    birthday: step1.birthday || undefined,
    gender: Number(step1.gender) || undefined,
    address1: step1.prefectures,
    email: step1.email || undefined,
    phone_no1: step1.tel1 + '-' + step1.tel2 + '-' + step1.tel3,
    mobile_flg1: 1,
    mobile_type1: Number(step1.mobile_type1) || 0,
  };

  if (sig) {
    params.sig = sig;
  }

  if (step1.tel4 && step1.tel5 && step1.tel6) {
    params.phone_no2 = step1.tel4 + '-' + step1.tel5 + '-' + step1.tel6;
    params.mobile_type2 = Number(step1.mobile_type2) || 0;
  }

  if (isCorporation) {
    params.company_name_kana = step1.companyNameKana || undefined;
    params.company_name = step1.companyName || '';
    params.company_flg = 1;
  }

  return params;
};
